// extracted by mini-css-extract-plugin
export default {"thead":"UserTable_thead__RMfrh","customBtn":"UserTable_customBtn__o05JY","table":"UserTable_table__tPb0E"};